import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE = 'https://evercorenutrition.com/ev_admin/api/refund';

export const requestRefund = createAsyncThunk('refund/request', async (data, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}/request/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed');
    return await res.json();
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

const refundSlice = createSlice({
  name: 'refund',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestRefund.pending, (state) => { state.loading = true; })
      .addCase(requestRefund.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(requestRefund.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default refundSlice.reducer;